import { FeatureFlagGate } from '@app/FeatureFlag/FeatureFlagGate'
import { FEATURE_FLAGS } from '@app/app-constants'
import { useDamageCostForSelectedElement } from '@app/hooks/useDamageCost'
import { DamageCostStat } from './DamageCostStat'

export interface SelectedElementDamageCostProps {
  element_layer_id: string | undefined
  asset_id: number | undefined
  hazard_scenario: string | undefined
}

/**
 * Renders a damage cost band for a single (asset, hazard) under a specific scenario
 * context. Self-gated by the `damageCostReporting` feature flag — safe to drop into
 * any selected-element card without an outer guard.
 */
export const SelectedElementDamageCost = ({
  element_layer_id,
  asset_id,
  hazard_scenario,
}: SelectedElementDamageCostProps) => {
  return (
    <FeatureFlagGate flag={FEATURE_FLAGS.DAMAGE_COST_REPORTING}>
      <SelectedElementDamageCostInner
        element_layer_id={element_layer_id}
        asset_id={asset_id}
        hazard_scenario={hazard_scenario}
      />
    </FeatureFlagGate>
  )
}

const SelectedElementDamageCostInner = ({
  element_layer_id,
  asset_id,
  hazard_scenario,
}: SelectedElementDamageCostProps) => {
  const { data, isLoading, isError } = useDamageCostForSelectedElement({
    element_layer_id,
    asset_id,
    hazard_scenario,
  })

  if (isError) {
    return (
      <DamageCostStat damage_cost_min={null} damage_cost_max={null} reason="no_damage_ratio_data" />
    )
  }

  return (
    <DamageCostStat
      damage_cost_min={data?.damage_cost_min}
      damage_cost_max={data?.damage_cost_max}
      reason={data?.reason}
      isLoading={isLoading}
    />
  )
}

export default SelectedElementDamageCost
